import { useQuery } from '@tanstack/react-query'
import { FeatureKey } from 'common/constants/permission'
import { FARMS_KEY, getFarmReverseGeocode, getFarmWeatherKey } from 'common/constants/queryKeys'
import { usePermitByFeature } from 'modules/user/api/selector'

import { getFarms, getFarmsReverseGeocode, getFarmsWeather } from '.'
import { TTL_5_MIN } from 'common/constants/staleTime'
import { useParams } from 'react-router'

// DOF-1278: this has already fired an ungated GET /farms for users with no
// Farm permission a couple of times (once from the sidebar's farm selector,
// again from the IoT detail/create/setting pages) - gate it here once so
// every current and future caller is covered, instead of gating each call
// site individually.
export const useFarms = () => {
  const canReadFarm = usePermitByFeature(FeatureKey.Farm)
  return useQuery({
    queryKey: FARMS_KEY,
    queryFn: async () => {
      const { data } = await getFarms()
      return data.data
    },
    staleTime: TTL_5_MIN,
    enabled: canReadFarm,
  })
}

export const useFarmsWeather = (farmId: string) => {
  return useQuery({
    queryKey: getFarmWeatherKey(farmId),
    queryFn: async () => {
      const { data } = await getFarmsWeather(farmId)
      return data.data
    },
    staleTime: TTL_5_MIN,
    enabled: !!farmId,
  })
}

export const useFarmsReverseGeocode = (lat: number, lng: number) => {
  return useQuery({
    queryKey: getFarmReverseGeocode(`${lat},${lng}`),
    queryFn: async () => {
      const { data } = await getFarmsReverseGeocode({ lat, lng })
      return data.data
    },
    staleTime: TTL_5_MIN,
    enabled: !!lat && !!lng,
  })
}
